module.exports = __webpack_public_path__ + "img/SL-M-140-180.b4664873.svg";